import React from 'react';
import ReportsOverview from '../components/Reports/ReportsOverview';
import '../components/LiveIntel/liveIntel.css';
import '../components/Reports/reports.css';

const ReportsOverviewPage = () => <ReportsOverview />;

export default ReportsOverviewPage;
